import React from "react";

import { WashingController } from "controllers";

class WashingSelect extends React.Component {

    constructor(props) {
        super(props);

        this.values = WashingController.getWashing()
        this.default_value = this.values.find(item => item.default).value;
        if (props.value) {
            this.default_value = props.value;
        }

        this.state = {
            washingValues: this.values,
            washing: this.default_value.value
        };

        this.resetState = this.resetState.bind(this);
        this.onChangeWashing = this.onChangeWashing.bind(this);
    }

    componentDidMount() {
        const washing = this.props.value || this.default_value;
        this.setState({ washing });
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            const washing = this.props.value;
            this.setState({ washing });
        }
    }

    onChangeWashing(washing) {
        this.setState({ washing });

        const { name, onChange } = this.props;
        if (onChange) {
            onChange({
                target: { name, value: washing }
            });
        }
    }

    resetState() {
        this.setState({ washing: this.default_value });
    }

    render() {
        const { washing, washingValues } = this.state;

        return (
            <React.Fragment>
                <label className="label">Washing Instructions</label>
                <div className="columns is-multiline">
                    {washingValues.map(washingValue =>
                        <div className="column is-4" key={washingValue.label}>
                            <button
                                type="button"
                                className={`button is-large is-fullwidth ${washingValue.value === washing ? 'is-link' : ''}`}
                                data-tooltip={washingValue.label}
                                onClick={() => this.onChangeWashing(washingValue.value)}>
                                <img src={washingValue.icon} alt={washingValue.value} style={{ height: '30px', width: 'auto', display: "block" }} />
                            </button>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default WashingSelect;
